import { z } from "zod";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";

export const requestSchema = z.object({
  email: z.string().email(),
  name: z.string().min(1),
  type: z.enum(["client", "company", "professional", "business"]),
  password: z.string().min(8),
  url: z.string(),
});

export default {
  method: HttpMethodEnum.POST,
  paramsType: HttpParamsTypeEnum.BODY,
  requestZodSchema: requestSchema,
  responseZodSchema: z.object({}),
} satisfies Route;
